'use strict';
var RelatedQueriesPosition;
(function (RelatedQueriesPosition) {
    RelatedQueriesPosition["AboveResultLayer"] = "aboveResultLayer";
    RelatedQueriesPosition["WithinResultLayer"] = "withinResultLayer";
    RelatedQueriesPosition["BelowResultLayer"] = "belowResultLayer";
})(RelatedQueriesPosition || (RelatedQueriesPosition = {}));
export default RelatedQueriesPosition;
